module.exports = __webpack_public_path__ + "img/onstore_icon.23f97f14.png";